<template>
  <OfficeLayout>
    <ProfileSettingsNav/>
    <router-view/>
  </OfficeLayout>
</template>

<script>
import {mapState} from "vuex";
import OfficeLayout from "@/components/layouts/cabinet/OfficeLayout";
import ProfileSettingsNav from "@/components/cabinet/ProfileSettings/ProfileSettingsNav";

export default {
  name: "TheProfile",
  components: {
    ProfileSettingsNav,
    OfficeLayout,
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('cabinet/user', ['user_info']),
  },
  created() {
    this.$store.dispatch('cabinet/user/getUserInfo', this.user_info.data.id)
  },
  beforeDestroy() {
    this.$store.dispatch('cabinet/passwordGuard/lockSettings');
  }
}
</script>
